const messages = {
    menuTitle: 'Wysyłki',
    pageTitle: 'Wysyłki',

    root: {
        menuTitle: 'Wysyłki',
        pageTitle: 'Wysyłki'
    },

    sendings: {
        menuTitle: 'Nadawanie',
        pageTitle: 'Wysyłki / Nadawanie',
        fallbackUserName: 'Operator',
        greeting: 'Witaj {userName}',
        today: 'Dziś jest {date}',
        workspace: {
            title: 'Stanowisko',
            empty: '-',
            select: 'Wybierz stanowisko',
            change: 'Zmień stanowisko',
            dialog: {
                title: 'Ustawienie stanowiska nadawczego',
                fieldLabel: 'Wybierz stanowisko',
                noData: 'Brak stanowisk'
            }
        },
        actions: {
            print: 'Drukuj',
            reprint: 'Wydrukuj ponownie',
            startSession: 'Rozpoczynam pracę',
            stopSession: 'Kończę na dziś',
            openScanner: 'Otwórz czytnik kodów',
            reportActivity: 'Raportuj czynność'
        },
        fields: {
            orderNumber: 'Numer zamówienia'
        },
        manualShipmentDialog: {
            title: 'Skanuj numer listu przewozowego',
            fields: {
                trackNumber: 'Numer listu przewozowego'
            },
            validations: {
                required: 'Numer listu przewozowego jest wymagany.',
                maxLength: 'Numer listu przewozowego może mieć maksymalnie {max} znaków.'
            }
        },
        menu: {
            couriers: 'Przewoźnicy',
            createAccident: 'Zgłoszenie awarii'
        },
        empty: {
            orderNotFound: 'Nie odnaleziono zamówienia.'
        },
        order: {
            addressCounter: 'Adres {current} z {total}',
            templateCounter: 'Nadanie {current} z {total}',
            actions: {
                confirmOrderComments: 'Potwierdzam zapoznanie się z komentarzem',
                finishSending: 'Zakończ nadawanie',
                generateNew: 'Generuj nowe',
                printLieferschein: 'Drukuj Lieferschein',
                recalculate: 'Przelicz',
                scanWaybill: 'Skanuj numer listu',
                send: 'Nadaj',
                showOrderComments: 'Pokaż uwagi do zamówienia'
            },
            alerts: {
                cashOnDeliveryPartialSent: 'Zamówienie nadane za pobraniem. Jeśli chcesz je ponownie nadać zrób to ręcznie.',
                inpostCarrierLocked:
                    'Przesyłka InPost ze sklepu. Kurier jest przypisany zgodnie z danymi ze sklepu i nie może zostać zmieniony.',
                inpostCarrierLockedDetails: 'Paczkomat: {lockerCode}, gabaryt: {shipmentSize}.',
                wmdCarrierLocked: 'Kurier jest przypisany zgodnie z danymi zamówienia i nie może zostać zmieniony.',
                containerCarrierLocked:
                    'Nadano już listy przewozowe dla tego adresu. Kuriera można zmienić po zakończeniu nadawania.',
                multiProject: 'Zamówienie wielowzorowe. Nie można nadać na linii.',
                multiProjectCashOnDelivery: 'Zamówienie wielowzorowe za pobraniem. Nie można nadać na linii.',
                shippingBlocked: 'Wysyłka zablokowana. Zostanie wygenerowana etykieta tymczasowa.',
                singleLabelLimitReached: 'Osiągnięto maksymalną liczbę etykiet dla tego zamówienia',
                standardCooperantOrder: 'To jest zamówienie wykonywane w kooperacji. Nadanie na linii nie jest możliwe.'
            },
            comments: {
                title: 'Uwagi do zamówienia'
            },
            boxes: {
                amount: 'Ilość',
                collectingBoxAmount: 'Ilość',
                collectingBoxType: 'Typ zbiorczego',
                packageType: 'Typ kartonu',
                shopDataBadge: 'Dane pobrane ze sklepu',
                sum: 'Suma:',
                errors: {
                    minPackageAmount: 'Osiągnięto minimalną ilość kartonów.',
                    maxPackageAmount: 'Osiągnięto maksymalną ilość kartonów.'
                }
            },
            fields: {
                amountToShip: 'Nakład:',
                city: 'Kod / miasto',
                country: 'Kraj',
                courier: 'Kurier:',
                orderNumber: 'Numer zamówienia',
                packageAmount: 'Kartony:',
                palletAmount: 'Ilość palet:',
                productFormat: 'Format',
                productType: 'Typ produktu',
                recipient: 'Odbiorca',
                status: 'Status:',
                street: 'Ulica',
                totalAmount: 'Nakład całkowity',
                weight: 'Waga:'
            },
            parameters: {
                format: 'Format:',
                orderNumber: 'Numer zamówienia:',
                productType: 'Rodzaj produktu:',
                previewAlt: 'Podgląd pliku zamówienia',
                status: 'Status zamówienia:',
                title: 'Parametry zamówienia',
                totalAmount: 'Nakład:'
            },
            statuses: {
                notSent: 'nie nadane',
                sent: 'nadane'
            },
            units: {
                pieces: 'szt.'
            }
        },
        alerts: {
            selectWorkspace: 'Wybierz stanowisko, aby rozpocząć pracę.',
            activeShipmentReport:
                'Masz aktywny raport czynności na aktualnym stanowisku. Za chwilę nastąpi przekierowanie do szczegółów raportu.'
        },
        processReportDialog: {
            title: 'Wybierz czynność',
            actions: {
                start: 'Rozpocznij'
            }
        },
        reportDetail: {
            pageTitle: 'Wysyłki / Nadawanie / Szczegóły raportu',
            headerTitle: 'Raportowanie / Szczegóły raportu',
            title: 'Czynność - {processName}',
            unknownProcess: 'Nieznana czynność',
            fields: {
                start: 'Data rozpoczęcia:',
                finish: 'Data zakończenia:',
                duration: 'Czas trwania:'
            },
            actions: {
                finish: 'Zakończ'
            }
        },
        sessionSummary: {
            title: 'Podsumowanie raportu',
            chartLabel: 'Procesy',
            fields: {
                start: 'Start:',
                stop: 'Stop:',
                duration: 'Zaraportowano:'
            },
            metrics: {
                user: 'Pracownik:',
                sentShipments: 'Ilość nadanych zamówień:',
                sentBoxes: 'Ilość nadanych kartonów:'
            }
        },
        templatesDialog: {
            title: 'Wybierz wzory',
            addressTitle: 'Wybierz adres',
            step: 'Krok {current} z {total}',
            address: 'Adres:',
            selectAll: 'Zaznacz wszystkie',
            confirm: 'Wybierz',
            sent: 'Nadane',
            orderNumber: 'Nr zamówienia'
        },
        stopSessionDialog: {
            title: 'Zakończenie dziennego raportu',
            content: 'Czy na pewno chcesz zakończyć pracę?',
            confirm: 'Zakończ'
        },
        sendPackageDialog: {
            title: 'Nadawanie paczki',
            content: 'Czy chcesz nadać paczkę?',
            confirm: 'Potwierdź'
        },
        pinDialog: {
            title: 'Wprowadź PIN',
            fields: {
                pin: 'PIN'
            }
        },
        packageAmountDialog: {
            title: 'Edycja liczby kartonów',
            fields: {
                packageAmount: 'Liczba kartonów'
            },
            errors: {
                range: 'Podaj liczbę z zakresu {min}-{max}.'
            }
        },
        amountToShipDialog: {
            title: 'Zmiana nakładu do nadania',
            fields: {
                amount: 'Nakład'
            },
            errors: {
                invalid: 'Proszę podać prawidłową wartość.'
            }
        },
        courierDialog: {
            title: 'Zmiana kuriera',
            fields: {
                courier: 'Kurier'
            },
            noData: 'Nie znaleziono kurierów'
        },
        couriersDialog: {
            title: 'Lista przewoźników',
            headers: {
                name: 'Nazwa',
                gateNumber: 'Numer bramki',
                actions: 'Akcje'
            },
            tooltips: {
                editGateNumber: 'Edytuj'
            },
            noData: 'Brak przewoźników',
            loading: 'Ładowanie przewoźników...'
        },
        gateNumberDialog: {
            title: 'Edycja numeru bramki',
            fields: {
                gateNumber: 'Numer bramki'
            },
            noData: 'Nie znaleziono numeru bramki',
            errors: {
                required: 'Proszę podać numer bramki.'
            }
        },
        reprintDialog: {
            title: 'Ponowny wydruk etykiet',
            headers: {
                carrier: 'Kurier',
                createdAt: 'Data wydruku',
                shippedAmount: 'Nakład',
                numberOfLabels: 'Liczba etykiet'
            }
        },
        pallets: {
            title: 'Palety',
            fields: {
                pallet: 'Paleta',
                amount: 'Nakład',
                packageAmount: 'Liczba kartonów'
            },
            placeholders: {
                pallet: 'Paleta',
                amount: 'Nakład',
                packageAmount: 'Liczba kartonów...'
            },
            headers: {
                number: 'Numer palety',
                pallet: 'Paleta',
                amount: 'Nakład',
                packageAmount: 'Liczba kartonów na palecie'
            },
            errors: {
                invalidAmount: 'Nakład nie jest prawidłowo rozdystrybuowany: {current} / {total}'
            },
            deletePalletDialog: {
                title: 'Usuwanie palety',
                content: 'Czy na pewno chcesz usunąć paletę?'
            }
        },
        package: {
            title: 'Paczka {number}',
            actions: {
                addPackageBox: 'Dodaj pakowanie',
                backToOrder: 'Wróć do zamówienia'
            },
            alerts: {
                pallet: 'Przesyłka wysyłana paletą.',
                standardCooperantOrder: 'Ta paczka wykonywana jest w kooperacji. Nadanie na linii nie jest możliwe.'
            },
            fields: {
                packageAmount: 'Ilość kartonów:'
            },
            statuses: {
                sent: 'wysłana',
                notSent: 'nie wysłana'
            },
            boxes: {
                headers: {
                    packageType: 'Typ opakowania',
                    amount: 'Ilość',
                    component: 'Typ kartonu'
                }
            },
            orders: {
                title: 'Zamówienia',
                headers: {
                    number: 'Numer zamówienia',
                    format: 'Format'
                }
            },
            errors: {
                packageAmountMismatch: 'Suma pakowań musi być równa liczbie kartonów paczki: {current}/{total}.'
            },
            deletePackageDialog: {
                title: 'Usuwanie pakowania',
                content: 'Czy na pewno chcesz usunąć pakowanie?'
            }
        },
        packageBoxDialog: {
            title: 'Pakowanie',
            fields: {
                packageType: 'Typ opakowania',
                component: 'Typ kartonu',
                packageAmount: 'Ilość'
            },
            errors: {
                required: 'Pole jest wymagane.',
                positive: 'Wartość musi być większa od zera.',
                maxPackageAmount: 'Suma pakowań nie może przekraczać liczby kartonów paczki.'
            }
        },
        notifications: {
            sessionStarted: 'Rozpoczęto sesję.',
            sessionStopped: 'Zakończono pracę.',
            cannotStartOnWorkspace: 'Nie można rozpocząć raportowania na wybranym stanowisku.',
            multiProject: 'Zamówienie wielowzorowe. Nie można nadać na linii.',
            multiProjectCashOnDelivery: 'Zamówienie wielowzorowe za pobraniem. Nie można nadać na linii.',
            higherPermissionsGranted: 'Odblokowano wyższe uprawnienia użytkownika.',
            labelsPrinted: 'Etykieta została wydrukowana.',
            manualShipmentCreated: 'Przesyłka została nadana.',
            labelsReprinted: 'Etykiety zostały wysłane do ponownego wydruku.',
            lieferscheinPrinted: 'Lieferschein został wydrukowany.',
            shipmentReportStarted: 'Rozpoczęto rejestrowanie czasu.',
            shipmentReportFinished: 'Zakończono rejestrowanie czasu.',
            courierUpdated: 'Przewoźnik został zedytowany.',
            sendingFinished: 'Zakończono nadawanie.',
            temporaryLabelsSaved: 'Poprawnie zapisano etykiety tymczasowe dla zamówienia.',
            unsupportedQrCode: 'Nieobsługiwany kod QR dla nadawania.'
        },
        errors: {
            fetchWorkspaces: 'Nie udało się pobrać stanowisk nadawczych.',
            fetchWorkspace: 'Nie udało się pobrać stanowiska nadawczego.',
            fetchCouriers: 'Nie udało się pobrać kurierów.',
            fetchGates: 'Nie udało się pobrać bram.',
            fetchSession: 'Nie udało się pobrać aktywnej sesji nadawania.',
            fetchActiveShipmentReport: 'Nie udało się pobrać aktywnego raportu czynności.',
            fetchShipmentReports: 'Nie udało się pobrać raportów czynności.',
            fetchShipmentReport: 'Nie udało się pobrać raportu czynności.',
            fetchReportProcesses: 'Nie udało się pobrać listy czynności.',
            fetchOrder: 'Nie udało się pobrać zamówienia.',
            missingPackageType: 'Adres nie ma typu opakowania — nie można nadać pojedynczego listu.',
            fetchPackage: 'Nie udało się pobrać paczki.',
            fetchBoxesInfo: 'Nie udało się pobrać informacji o kartonach.',
            fetchPackageTypes: 'Nie udało się pobrać typów opakowań.',
            fetchBoxTypes: 'Nie udało się pobrać typów kartonów.',
            updateAddress: 'Edycja adresu nie powiodła się.',
            updateCourier: 'Edycja przewoźnika nie powiodła się.',
            recalculateUnitBox: 'Edycja kartonów zbiorczych nie powiodła się.',
            printLabels: 'Wygenerowanie etykiet nie powiodło się.',
            fetchSendingContainer: 'Nie udało się pobrać stanu nadawania dla adresu.',
            finishSending: 'Zakończenie nadawania nie powiodło się.',
            createManualShipment: 'Ręczne nadanie przesyłki nie powiodło się.',
            reprintLabels: 'Ponowny wydruk etykiet nie powiódł się.',
            printLieferschein: 'Wydruk Lieferschein nie powiódł się.',
            createShipmentReport: 'Rejestrowanie czasu nie powiodło się.',
            finishShipmentReport: 'Zakończenie raportu nie powiodło się.',
            startSession: 'Nie udało się rozpocząć sesji nadawania.',
            stopSession: 'Nie udało się zakończyć sesji nadawania.'
        }
    },

    shippingLabels: {
        menuTitle: 'Zawieszki',
        pageTitle: 'Wysyłki / Zawieszki',
        listPageTitle: 'Wysyłki / Zawieszki / Etykiety',
        createPageTitle: 'Wysyłki / Zawieszki / Nowa etykieta',
        editPageTitle: 'Wysyłki / Zawieszki / Edycja etykiety',
        campaignEditPageTitle: 'Wysyłki / Zawieszki / Edycja etykiety kampanii',
        title: 'Zawieszki / Etykiety',
        actions: {
            createFromOrder: 'Zawieszka z zamówienia',
            createFromShippingOrder: 'Zawieszka z ZS',
            createCarrierLabel: 'Etykieta kurierska',
            createAdditionalLabel: 'Zawieszki dodatkowe',
            createCampaignLabel: 'Zawieszka z kampanii',
            open: 'Otwórz',
            print: 'Drukuj',
            printPackage: 'Drukuj etykietę opakowaniową',
            printGoods: 'Drukuj etykietę towaru',
            delete: 'Usuń'
        },
        tooltips: {
            unavailableInCurrentPart: 'Ta akcja będzie dostępna w kolejnym etapie migracji.'
        },
        list: {
            filters: {
                type: 'Typ',
                typeNoData: 'Nie znaleziono typów',
                status: 'Status',
                statusNoData: 'Nie znaleziono statusów',
                number: 'Nr zawieszki',
                customer: 'Klient',
                sourceObjectNumber: 'Numer zlecenia/zamówienia'
            },
            headers: {
                number: 'Nr zawieszki',
                createdAt: 'Data utworzenia',
                source: 'Źródło danych',
                sourceObjectNumber: 'Numer zlecenia/zamówienia',
                customer: 'Klient',
                status: 'Status',
                actions: 'Akcje'
            },
            dialogs: {
                deleteTitle: 'Usuwanie zawieszki',
                deleteContent: 'Czy na pewno chcesz usunąć zawieszkę?'
            },
            tooltips: {
                generateLabel: 'Generuj etykietę'
            }
        },
        carrierDialog: {
            createTitle: 'Tworzenie etykiety kurierskiej',
            printTitle: 'Wydruk etykiety kurierskiej',
            fields: {
                template: 'Szablon etykiety',
                sendDate: 'Data wysyłki'
            },
            noDataText: 'Nie znaleziono szablonów',
            validations: {
                templateRequired: 'Szablon jest wymagany.',
                sendDateRequired: 'Proszę wybrać datę wysyłki.'
            }
        },
        additionalDialog: {
            createTitle: 'Tworzenie etykiety dodatkowej',
            printTitle: 'Wydruk etykiety dodatkowej',
            fields: {
                destination: 'Przeznaczenie',
                palletsQuantity: 'Liczba palet',
                palletType: 'Rodzaj palety'
            },
            noDestinationText: 'Nie znaleziono',
            noPalletText: 'Nie znaleziono palet',
            validations: {
                destinationRequired: 'Proszę wybrać przeznaczenie.',
                palletsQuantityRequired: 'Liczba palet jest wymagana.',
                palletsQuantityPositive: 'Proszę podać całkowitą dodatnią liczbę palet.',
                palletTypeRequired: 'Proszę wybrać rodzaj palety.'
            }
        },
        labelTemplateDialog: {
            title: 'Wybór szablonu',
            actions: {
                choose: 'Wybierz'
            },
            fields: {
                template: 'Szablon'
            },
            noData: 'Nie znaleziono szablonów',
            validations: {
                templateRequired: 'Proszę wybrać szablon.'
            }
        },
        printTemplatesDialog: {
            title: 'Drukowanie etykiet',
            fields: {
                printAll: 'Drukuj wszystkie',
                printLogistics: 'Drukuj etykiety logistyczne',
                printPallets: 'Drukuj zawieszki paletowe',
                printSets: 'Drukuj etykiety zestawów',
                logisticsLabel: 'Etykieta logistyczna',
                name: 'Nazwa',
                template: 'Szablon'
            }
        },
        campaignDialog: {
            title: 'Tworzenie zawieszki z kampanii',
            sections: {
                closedCampaigns: 'Zamknięte kampanie'
            },
            filters: {
                number: 'Numer kampanii'
            },
            headers: {
                number: 'Numer kampanii',
                actions: 'Akcje'
            },
            actions: {
                create: 'Utwórz'
            },
            tooltips: {
                unavailable: 'Utworzenie zawieszki jest niedostępne dla tej kampanii.'
            }
        },
        scaffold: {
            listTitle: 'Zawieszki',
            editorTitle: 'Etykieta',
            campaignEditorTitle: 'Etykieta kampanijna'
        },
        importDialog: {
            titles: {
                ecommerceOrder: 'Tworzenie zawieszki z zamówienia',
                shippingOrder: 'Tworzenie zawieszki ze zlecenia spedycyjnego'
            },
            actions: {
                create: 'Utwórz'
            },
            fields: {
                ecommerceOrder: 'Numer zamówienia',
                shippingOrder: 'Numer zlecenia spedycyjnego'
            },
            hints: {
                ecommerceOrder: 'Wpisz lub zeskanuj numer zamówienia',
                shippingOrder: 'Wpisz numer zlecenia spedycyjnego'
            },
            noData: {
                ecommerceOrder: 'Wpisz treść aby odnaleźć zamówienie.',
                shippingOrder: 'Wpisz treść aby odnaleźć zlecenie spedycyjne.'
            },
            search: {
                loadingEcommerceOrder: 'Trwa wyszukiwanie zamówień...',
                loadingShippingOrder: 'Trwa wyszukiwanie zleceń...',
                notFoundEcommerceOrder: 'Nie odnaleziono zamówień dla zapytania: "{query}".',
                notFoundScannedEcommerceOrder: 'Nie znaleziono zamówienia.',
                notFoundShippingOrder: 'Nie odnaleziono zleceń dla zapytania: "{query}".',
                minLength: 'Wpisz przynajmniej {count} znaki.'
            },
            validations: {
                ecommerceOrderRequired: 'Numer zamówienia jest wymagany.',
                shippingOrderRequired: 'Numer zlecenia spedycyjnego jest wymagany.'
            }
        },
        editor: {
            pageTitle: {
                create: 'Wysyłki / Zawieszki / Nowa etykieta',
                edit: 'Wysyłki / Zawieszki / Edycja etykiety'
            },
            sections: {
                labelParameters: 'Parametry zawieszki',
                customerData: 'Dane klienta',
                goods: 'Towary',
                packages: 'Opakowania',
                addresses: 'Adresy',
                history: 'Historia zmian',
                latestUpdatedBy: 'Ostatnio edytowany',
                lastUpdated: 'Ostatnio edytowany przez'
            },
            actions: {
                back: 'Powrót do listy',
                save: 'Zapisz',
                openHistory: 'Historia zmian',
                addGood: 'Dodaj towar',
                addPackageConfiguration: 'Dodaj konfigurację',
                addPackage: 'Dodaj pakowanie',
                addAddress: 'Dodaj adres',
                copyAddress: 'Kopiuj adres',
                edit: 'Edytuj',
                open: 'Otwórz',
                delete: 'Usuń',
                printAll: 'Drukuj wszystko',
                changeReadyToPrint: 'Gotowa do druku'
            },
            fields: {
                createdAt: 'Data utworzenia',
                createdBy: 'Utworzona przez',
                name: 'Nazwa',
                nip: 'NIP',
                address: 'Adres',
                phone: 'Telefon',
                product: 'Produkt',
                code: 'Kod',
                goodCode: 'Kod Towaru',
                boxType: 'Sposób pakowania',
                packageType: 'Opakowanie',
                length: 'Długość',
                width: 'Szerokość',
                height: 'Wysokość',
                weight: 'Waga',
                grossWeight: 'Brutto',
                capacity: 'Nośność',
                companyName: 'Nazwa firmy',
                contactPerson: 'Osoba kontaktowa',
                street: 'Ulica',
                postCode: 'Kod pocztowy',
                city: 'Miasto',
                country: 'Kraj',
                plannedShippingDate: 'Planowana data wysyłki',
                deliveryDate: 'Data dostawy',
                transportType: 'Środek transportu',
                availableAmount: 'Do wysyłki',
                manualUpdate: 'Ręczna edycja',
                updateAfterWeigh: 'Edycja po ważeniu'
            },
            addresses: {
                title: 'Adresy',
                packagesTitle: 'Pakowanie',
                goodsTitle: 'Towary',
                deletePackages: 'Usuń pakowania',
                noAddresses: 'Brak adresów.',
                noPackages: 'Brak pakowania.',
                packageDimensions: 'Wymiary pakowania',
                printPackageUnavailable: 'Drukowanie pakowania będzie dostępne w kolejnym etapie migracji.',
                printProductUnavailable: 'Drukowanie etykiety opakowaniowej będzie dostępne w kolejnym etapie migracji.',
                packageAmountMismatch: 'Niezgodność nakładu, skoryguj aby przejść do zakładki ADRESY.'
            },
            confirmations: {
                deleteAddressTitle: 'Usuwanie adresu',
                deleteAddressContent: 'Czy na pewno chcesz usunąć adres?',
                deletePackageTitle: 'Usuwanie opakowania',
                deletePackageContent: 'Czy na pewno chcesz usunąć opakowanie?',
                deleteProductTitle: 'Usuwanie towaru',
                deleteProductContent: 'Czy na pewno chcesz usunąć towar?',
                copyAddressTitle: 'Kopiowanie adresu',
                copyAddressContent: 'Czy chcesz skopiować dane adresowe na pozostałe pozycje?'
            },
            tables: {
                goods: {
                    headers: {
                        product: 'Produkt',
                        code: 'Kod Towaru',
                        packedAmount: 'Ilość przydzielona',
                        availableAmount: 'Do wysyłki',
                        actions: 'Akcje'
                    },
                    noData: 'Brak danych'
                },
                packages: {
                    headers: {
                        product: 'Produkt',
                        code: 'Kod Towaru',
                        packageTypeAndQuantity: 'Rodzaj i ilość kartonów',
                        inPackageQuantity: 'Ilość w opakowaniu',
                        defaultAmount: 'Nakład początkowy',
                        shippingAmount: 'Do wysyłki',
                        actions: 'Akcje'
                    },
                    noData: 'Brak danych'
                },
                packageProducts: {
                    headers: {
                        product: 'Towar',
                        amount: 'Nakład',
                        packagesQuantity: 'Ilość kartonów',
                        weight: 'Netto / Brutto',
                        actions: 'Akcje'
                    },
                    noData: 'Brak danych'
                }
            },
            history: {
                headers: {
                    user: 'Użytkownik',
                    dateTime: 'Data i godzina'
                },
                itemsPerPageText: 'Zmian na stronie'
            },
            goodDialog: {
                title: 'Towar',
                editTitle: 'Edycja towaru'
            },
            validations: {
                goodNameRequired: 'Proszę podać nazwę produktu.',
                goodNameUnique: 'Wybrany produkt istnieje już w tej zawieszce.',
                invalidFormat: 'Niepoprawny format.',
                goodCodeMaxLength: 'Pole może zawierać maksymalnie 30 cyfr.',
                availableAmountRequired: 'Proszę podać ilość.',
                invalidForm: 'Proszę wypełnić poprawnie wymagane pola.'
            },
            notifications: {
                saved: 'Zawieszka została zapisana.',
                packageAdded: 'Opakowanie zostało dodane.',
                packageUpdated: 'Opakowanie zostało zaktualizowane.'
            },
            tooltips: {
                unavailableInCurrentPart: 'Ta akcja będzie dostępna w kolejnym etapie migracji.',
                manualUpdateRequired: 'Włącz ręczną edycję, aby dodać konfigurację.',
                noGoodsLeftToAssign: 'Wszystkie towary zostały już przypisane do konfiguracji.'
            }
        },
        addressDialog: {
            titles: {
                details: 'Szczegóły adresu',
                create: 'Dodaj adres',
                edit: 'Edycja adresu'
            },
            sections: {
                sender: 'Dostawca',
                recipient: 'Odbiorca'
            },
            fields: {
                selectSenderAddress: 'Wybierz z dostępnych adresów',
                selectRecipientAddress: 'Wybierz z dostępnych adresów',
                companyName: 'Nazwa firmy',
                firstName: 'Imię',
                lastName: 'Nazwisko',
                contactPerson: 'Osoba kontaktowa',
                street: 'Ulica',
                postCode: 'Kod pocztowy',
                city: 'Miasto',
                country: 'Kraj',
                phone: 'Telefon',
                plannedShippingDate: 'Planowana data wysyłki'
            },
            noData: {
                addresses: 'Brak adresów',
                countries: 'Nie znaleziono kraju'
            },
            validations: {
                companyNameRequired: 'Proszę podać nazwę firmy.',
                contactPersonRequired: 'Proszę podać osobę do kontaktu.',
                streetRequired: 'Proszę podać ulicę.',
                postCodeRequired: 'Proszę podać kod pocztowy.',
                cityRequired: 'Proszę podać miasto.',
                countryRequired: 'Proszę wybrać kraj.',
                plannedShippingDateRequired: 'Proszę podać planowaną datę wysyłki.',
                phoneRequired: 'Proszę podać numer telefonu.',
                senderCompanyNameRequired: 'Proszę podać nazwę firmy.',
                senderStreetRequired: 'Proszę podać ulicę.',
                senderPostCodeRequired: 'Proszę podać kod pocztowy.',
                senderCityRequired: 'Proszę podać miasto.'
            }
        },
        packageDialog: {
            titles: {
                details: 'Pakowanie',
                create: 'Dodaj pakowanie',
                edit: 'Edycja pakowania'
            },
            fields: {
                boxType: 'Sposób pakowania',
                packageType: 'Opakowanie',
                packageWeight: 'Waga palety/opakowania',
                maxWeightCapacity: 'Nośność opakowania',
                elementsAmount: 'Ilość elementów'
            },
            hints: {
                elementsAmount: 'Ilość opakowań o tych samych parametrach'
            },
            noData: {
                boxTypes: 'Nie znaleziono sposobów pakowania',
                packageTypes: 'Nie znaleziono opakowań'
            },
            validations: {
                boxTypeRequired: 'Proszę podać sposób pakowania.',
                packageTypeRequired: 'Proszę podać rodzaj opakowania.',
                lengthRequired: 'Proszę podać długość.',
                widthRequired: 'Proszę podać szerokość.',
                heightRequired: 'Proszę podać wysokość.',
                packageWeightRequired: 'Proszę podać wagę.',
                maxWeightCapacityInvalid: 'Proszę podać poprawną nośność opakowania.'
            }
        },
        productDialog: {
            titles: {
                details: 'Towar',
                edit: 'Edycja ilości opakowań'
            },
            fields: {
                product: 'Produkt',
                packageType: 'Opakowanie',
                piecesAmount: 'Ilość sztuk',
                packagesAmount: 'Ilość opakowań'
            },
            noData: {
                packageTypes: 'Nie znaleziono opakowań'
            },
            validations: {
                productRequired: 'Proszę wybrać produkt.',
                packageTypeRequired: 'Proszę wybrać rodzaj opakowania.',
                quantityRequired: 'Proszę podać ilość.',
                quantityBetween: 'Proszę podać wartość z zakresu {min}-{max}'
            }
        },
        productsDialog: {
            title: 'Lista produktów',
            fields: {
                search: 'Produkt'
            },
            headers: {
                product: 'Produkt',
                packageType: 'Opakowanie',
                inPackageQuantity: 'W opakowaniu',
                amount: 'Ilość',
                actions: 'Akcje'
            },
            noData: 'Brak danych'
        },
        packagesConfigurationDialog: {
            title: 'Towar',
            addTitle: 'Dodaj towar',
            editTitle: 'Edycja towaru',
            fields: {
                packageType: 'Opakowanie',
                amount: 'Nakład',
                packageWeight: 'Waga opakowania',
                packageCapacity: 'Nośność opakowania',
                manualPackageEdit: 'Ręczna edycja ilości opakowań',
                packagesQuantity: 'Ilość opakowań',
                inPackageQuantity: 'Ilość w opakowaniu'
            },
            hints: {
                productFullyAssigned: 'Produkt w pełni rozpisany.'
            },
            alerts: {
                unsavedData: 'Dane nie są zapisane.'
            },
            validations: {
                productRequired: 'Proszę wybrać produkt.',
                amountRequired: 'Proszę podać ilość.',
                exceededAvailableAmount: 'Przekroczono dostępny nakład',
                amountBetween: 'Proszę podać wartość z zakresu {min}-{max}',
                packageTypeRequired: 'Proszę wybrać rodzaj opakowania.',
                lengthRequired: 'Proszę podać długość.',
                widthRequired: 'Proszę podać szerokość.',
                heightRequired: 'Proszę podać wysokość.',
                weightRequired: 'Proszę podać wagę.',
                capacityRequired: 'Proszę podać nośność.',
                packagesQuantityRequired: 'Liczba opakowań jest wymagana',
                packagesQuantityInvalid: 'Proszę podać całkowitą dodatnią liczbę opakowań',
                packagesQuantityExceeded: 'Przekroczono liczbę opakowań',
                inPackageQuantityRequired: 'Ilość w opakowaniu jest wymagana',
                inPackageQuantityInvalid: 'Ilość w opakowaniu musi być liczbą całkowitą dodatnią',
                inPackageQuantityExceeded: 'Przekroczono ilość w opakowaniu'
            }
        },
        service: {
            fetchListError: 'Pobranie listy zawieszek nie powiodło się.',
            fetchDetailsError: 'Pobranie danych dla zawieszki nie powiodło się.',
            createFromShippingOrderError: 'Dodanie zawieszki nie powiodło się.',
            createFromEcommerceOrderError: 'Dodanie zawieszki nie powiodło się.',
            createFromCampaignError: 'Dodanie zawieszki z kampanii nie powiodło się.',
            updateError: 'Edycja zawieszki nie powiodła się.',
            deleteError: 'Usunięcie zawieszki nie powiodło się.',
            printError: 'Wygenerowanie wydrukow nie powiodlo sie.',
            printSsccError: 'Wygenerowanie etykiety logistycznej nie powiodło się.',
            printBulkSsccError: 'Wygenerowanie etykiet logistycznych nie powiodło się.',
            fetchTemplatesError: 'Pobranie dostępnych szablonów nie powiodło się.',
            fetchStatusesError: 'Pobranie statusów zawieszek nie powiodło się.',
            fetchTypesError: 'Pobranie typów zawieszek nie powiodło się.',
            fetchDestinationsError: 'Pobranie miejsc przeznaczenia nie powiodło się.',
            fetchShippingOrdersError: 'Pobranie listy zleceń spedycyjnych nie powiodło się.',
            fetchOrdersError: 'Pobranie listy zamówień e-commerce nie powiodło się.',
            fetchCampaignsError: 'Pobranie listy kampanii nie powiodło się.',
            fetchBoxTypesError: 'Pobranie typów pakowania nie powiodło się.',
            fetchPackageTypesError: 'Pobranie typów opakowań nie powiodło się.',
            fetchCustomerAddressesError: 'Pobranie adresów klienta nie powiodło się.',
            fetchCountriesError: 'Pobranie listy krajów nie powiodło się.',
            createCarrierLabelError: 'Dodanie etykiety kurierskiej nie powiodło się.',
            createAdditionalLabelError: 'Dodanie zawieszki dodatkowej nie powiodło się.',
            updateGoodError: 'Aktualizacja towaru nie powiodła się.',
            createPackageConfigurationError: 'Dodanie konfiguracji opakowania nie powiodło się.',
            updatePackageConfigurationError: 'Aktualizacja konfiguracji opakowania nie powiodła się.',
            deletePackageConfigurationError: 'Usunięcie konfiguracji opakowania nie powiodło się.'
        },
        campaignEditor: {
            headers: {
                description: 'Opis'
            },
            labels: {
                noAddress: 'Brak adresu'
            },
            goodsDialog: {
                title: 'Lista pakietów',
                headers: {
                    name: 'Nazwa',
                    code: 'Kod EAN',
                    index: 'Indeks',
                    amount: 'Ilość'
                }
            },
            tooltips: {
                printLogisticsLabel: 'Drukuj etykietę logistyczną',
                printPalletLabel: 'Drukuj etykietę paletową',
                printSetLabel: 'Drukuj etykietę zestawu'
            },
            printTemplates: {
                pallet: 'Paleta kampania',
                set: 'Pakiet kampania'
            },
            notifications: {
                notEnoughGoodsToCreatePallet: 'Nie można dodać palety. Brakuje pakietów do rozpisania.',
                invalidGoodsMove: 'Suma wybranych ilości musi być mniejsza od sumy dostępnych ilości o co najmniej 1.'
            }
        }
    },

    personalPickups: {
        menuTitle: 'Odbiory osobiste',
        list: {
            pageTitle: 'Odbiory osobiste',
            actions: {
                createWz: 'Dodaj WZ',
                createPackage: 'Dodaj paczkę'
            },
            table: {
                headers: {
                    number: 'Numer',
                    customer: 'Odbiorca',
                    createdBy: 'Utworzone przez',
                    createdAt: 'Data utworzenia',
                    status: 'Status',
                    actions: 'Akcje'
                }
            },
            tooltips: {
                print: 'Drukuj',
                open: 'Otwórz',
                delete: 'Usuń'
            },
            dialogs: {
                delete: {
                    title: 'Usuwanie odbioru osobistego',
                    content: 'Czy na pewno chcesz usunąć odbiór osobisty?',
                    confirmButton: 'Usuń'
                }
            }
        },
        details: {
            pageTitleCreate: 'Tworzenie odbioru osobistego',
            pageTitleEdit: 'Wysyłki / Odbiory osobiste / Odbiór osobisty - {number}',
            actions: {
                backToList: 'Powrót do listy',
                save: 'Zapisz',
                confirmWz: 'Potwierdź WZ',
                addOrder: 'Dodaj zamówienie na WZ',
                print: 'Drukuj'
            },
            tooltips: {
                printBeforeSave: 'Przed wydrukiem zapisz zmiany',
                print: 'Drukuj',
                delete: 'Usuń'
            },
            card: {
                title: 'Dane odbioru osobistego',
                fields: {
                    number: 'Numer:',
                    createdBy: 'Utworzony przez:',
                    createdAt: 'Data utworzenia:'
                }
            },
            ordersTable: {
                title: 'Zamówienia na WZ',
                empty: 'Brak zamówień na WZ.',
                headers: {
                    shopOrderNumber: 'Numer zamówienia klienta',
                    productionNumber: 'Numer zamówienia',
                    firstProductName: 'Produkt',
                    amount: 'Nakład odebrany',
                    packageAmount: 'Ilość kartonów',
                    isPartialPickup: 'Odbiór częściowy',
                    actions: 'Akcje'
                },
                inline: {
                    amountLabel: 'Nakład',
                    packageAmountLabel: 'Kartony',
                    save: 'Zapisz',
                    cancel: 'Anuluj'
                }
            },
            dialogs: {
                confirm: {
                    content: 'Czy na pewno chcesz potwierdzić odbiór osobisty?',
                    confirmButton: 'Potwierdź'
                }
            }
        },
        packageDetails: {
            pageTitleCreate: 'Tworzenie odbioru osobistego',
            pageTitleEdit: 'Edycja odbioru osobistego (paczka) {number}',
            actions: {
                backToList: 'Powrót do listy',
                save: 'Zapisz',
                confirmWz: 'Potwierdź WZ',
                addPackage: 'Dodaj paczkę do WZ'
            },
            tooltips: {
                printBeforeSave: 'Zapisz zmiany, aby wydrukować',
                print: 'Drukuj',
                deletePackage: 'Usuń paczkę'
            },
            card: {
                title: 'Dane odbioru osobistego',
                fields: {
                    number: 'Numer:',
                    createdBy: 'Utworzony przez:',
                    createdAt: 'Data utworzenia:'
                }
            },
            packagesTable: {
                title: 'Paczka na WZ',
                addedPackages: 'Dodane paczki',
                empty: 'Brak paczek na WZ.',
                headers: {
                    packageNumber: 'Numer paczki',
                    customerName: 'Klient',
                    ordersCount: 'Liczba zamówień',
                    packagesCount: 'Liczba kartonów',
                    actions: 'Akcje'
                },
                ordersHeaders: {
                    shopOrderNumber: 'Numer zamówienia klienta',
                    productionNumber: 'Numer zamówienia',
                    firstProductName: 'Produkt',
                    quantity: 'Nakład'
                }
            },
            dialogs: {
                confirm: {
                    content: 'Czy na pewno chcesz potwierdzić odbiór osobisty?',
                    confirmButton: 'Potwierdź'
                },
                editPackageCount: {
                    title: 'Liczba kartonów',
                    field: 'Liczba kartonów',
                    confirmButton: 'Potwierdź'
                }
            }
        },
        ordersDialog: {
            title: 'Zamówienia z odbiorem osobistym',
            filters: {
                customerName: 'Klient',
                shopOrderNumber: 'Numer zamówienia'
            },
            table: {
                headers: {
                    customer: 'Klient',
                    shopOrderNumber: 'Numer zamówienia klienta',
                    productionNumber: 'Numer zamówienia',
                    productName: 'Produkt',
                    status: 'Status zamówienia',
                    quantity: 'Nakład',
                    quantityLeft: 'Pozostało'
                }
            },
            actions: {
                cancel: 'Anuluj',
                save: 'Dodaj',
                openScanner: 'Otwórz czytnik kodów'
            }
        },
        packagesDialog: {
            title: 'Paczka z odbiorem osobistym',
            filters: {
                customer: 'Klient',
                packageNumber: 'Numer paczki'
            },
            table: {
                headers: {
                    packageNumber: 'Numer paczki',
                    customerName: 'Klient',
                    ordersCount: 'Liczba zamówień',
                    packagesCount: 'Liczba kartonów',
                    totalAmount: 'Całkowita kwota'
                }
            },
            actions: {
                cancel: 'Anuluj',
                save: 'Dodaj'
            }
        },
        errors: {
            fetchList: 'Pobranie listy odbiorów osobistych nie powiodło się.',
            fetchDetail: 'Pobranie danych do odbioru osobistego {id} nie powiodło się.',
            create: 'Dodanie odbioru osobistego nie powiodło się.',
            update: 'Zapis odbioru osobistego nie powiódł się.',
            delete: 'Usunięcie odbioru osobistego nie powiodło się.',
            fetchOrders: 'Pobranie listy zamówień z odbiorem osobistym nie powiodło się.',
            fetchPackages: 'Pobranie danych do odbiorów osobistych nie powiodło się.'
        },
        notifications: {
            created: 'Odbiór osobisty został dodany.',
            updated: 'Odbiór osobisty został zedytowany.',
            deleted: 'Odbiór osobisty został usunięty.'
        }
    },

    service: {
        fetchPersonalPickupsError: 'Pobranie listy odbiorów osobistych nie powiodło się.',
        fetchPersonalPickupError: 'Pobranie danych do odbioru osobistego nie powiodło się.',
        createPersonalPickupSuccess: 'Odbiór osobisty został dodany.',
        createPersonalPickupError: 'Dodanie odbioru osobistego nie powiodło się.',
        updatePersonalPickupSuccess: 'Odbiór osobisty został zedytowany.',
        updatePersonalPickupError: 'Zapis odbioru osobistego nie powiódł się.',
        deletePersonalPickupSuccess: 'Odbiór osobisty został usunięty.',
        deletePersonalPickupError: 'Usunięcie odbioru osobistego nie powiodło się.',
        fetchOrdersError: 'Pobranie listy zamówień z odbiorem osobistym nie powiodło się.',
        fetchPackagesError: 'Pobranie danych do odbiorów osobistych nie powiodło się.'
    },
    labelsGenerator: {
        menuTitle: 'Generator etykiet',
        pageTitle: 'Wysyłki / Generator etykiet',
        description: 'Wybierz rodzaj etykiet do wygenerowania',
        workspaceCard: {
            title: 'Stanowisko',
            changeTooltip: 'Zmiana stanowiska',
            printerLabel: 'Drukarka',
            noPrinters: 'Nie znaleziono drukarki'
        },
        all: {
            pageTitle: 'Generator Etykiet',
            cards: {
                standard: {
                    title: 'Etykiety standardowe',
                    description: 'Wydruk etykiet standardowych',
                    open: 'Otwórz'
                },
                billboard: {
                    title: 'Etykiety billboardowe',
                    description: 'Wydruk etykiet dla billboardów',
                    open: 'Otwórz'
                },
                revisory: {
                    title: 'Etykiety rewizyjne',
                    description: 'Wydruk etykiet rewizyjnych',
                    open: 'Otwórz'
                },
                history: {
                    title: 'Historia',
                    description: 'Zestawienie informacji o wydrukach etykiet',
                    open: 'Otwórz'
                }
            }
        },
        standard: {
            pageTitle: 'Generator etykiet standardowych',
            clientLabel: 'Klient',
            actions: {
                back: 'Powrót',
                workspace: 'Zmiana stanowiska',
                generateFromFile: 'Importuj dane',
                importFromCampaign: 'Importuj z kampanii',
                add: 'Dodaj',
                print: 'Wydrukuj wszystkie etykiety',
                import: 'Importuj'
            },
            errorFormat: 'Wygląda na to, że format pliku nie jest zgodny z szablonem wybranego klienta.',
            table: {
                shopFormat: 'Format sklepu',
                shopIndex: 'Indeks',
                ean: 'EAN',
                copies: 'Ilość',
                number: 'Numer',
                name: 'Nazwa',
                shop: 'Sklep',
                city: 'Miasto',
                actions: 'Akcje'
            },
            dialogs: {
                delete: {
                    title: 'Usuwanie etykiety',
                    content: 'Czy na pewno chcesz usunąć etykietę?',
                    confirm: 'Usuń'
                },
                updateData: {
                    title: 'Czy jesteś pewien?',
                    content: 'Wszystkie dane zostaną utracone',
                    confirm: 'Kontynuuj'
                }
            }
        },
        dialogs: {
            workspaceSettings: {
                title: 'Ustawienie stanowiska',
                label: 'Wybierz stanowisko',
                cancel: 'Anuluj'
            },
            generateLabels: {
                title: 'Import danych',
                fileLabel: 'Plik excel',
                placeholder: 'Wybierz plik',
                cancel: 'Anuluj',
                confirm: 'Potwierdź',
                invalidFormat: 'Nieprawidłowy format pliku',
                parseError: 'Błąd parsowania pliku'
            },
            generateBillboardLabels: {
                title: 'Generuj etykiety billboardowe z pliku',
                fileLabel: 'Plik excel',
                placeholder: 'Wybierz plik',
                cancel: 'Anuluj',
                confirm: 'Potwierdź',
                invalidFormat: 'Nieprawidłowy format pliku',
                parseError: 'Błąd parsowania pliku'
            },
            addEditEAN: {
                title: 'Dodaj nową etykietę',
                shopFormat: 'format sklepu',
                shopIndex: 'indeks',
                ean: 'EAN',
                copies: 'ilość',
                cancel: 'Anuluj',
                save: 'Zapisz',
                validation: {
                    required: 'To pole jest wymagane',
                    invalidFormat: 'Nieprawidłowy format',
                    minValue: 'Minimalna wartość to 0'
                }
            },
            addEditCity: {
                title: 'Dodaj nową etykietę',
                number: 'Numer',
                name: 'Nazwa',
                shop: 'Sklep',
                city: 'Miasto',
                cancel: 'Anuluj',
                save: 'Zapisz',
                validation: {
                    required: 'To pole jest wymagane',
                    invalidFormat: 'Nieprawidłowy format',
                    minValue: 'Minimalna wartość to 0'
                }
            },
            importCampaign: {
                title: 'Importuj dane z kampanii',
                searchLabel: 'Wyszukaj kampanię',
                noData: 'Brak danych',
                close: 'Zamknij',
                headers: {
                    number: 'Numer kampanii',
                    actions: 'Akcje'
                }
            }
        },
        service: {
            printEANLabelsError: 'Drukowanie etykiet EAN nie powiodło się.',
            printCustomLabelsError: 'Drukowanie etykiet niestandardowych nie powiodło się.',
            printBillboardLabelsError: 'Drukowanie etykiet billboardowych nie powiodło się.',
            printRevisionLabelError: 'Drukowanie etykiety rewizyjnej nie powiodło się.',
            fetchLabelsCampaignError: 'Pobranie danych kampanii nie powiodło się.',
            fetchProductionSitesError: 'Pobranie listy stanowisk nie powiodło się.',
            fetchProductionSiteError: 'Pobranie danych stanowiska nie powiodło się.',
            searchCampaignsError: 'Wyszukiwanie kampanii nie powiodło się.',
            fetchLastClosedCampaignError: 'Pobranie ostatniej zamkniętej kampanii nie powiodło się.',
            fetchBillboardCustomersError: 'Pobranie listy klientów billboardowych nie powiodło się.',
            getRevisionLabelDetailsError: 'Pobranie szczegółów etykiety rewizyjnej nie powiodło się.',
            getLabelsPrintHistoryError: 'Pobranie historii wydruków nie powiodło się.',
            searchUsersError: 'Wyszukiwanie użytkowników nie powiodło się.'
        },
        billboard: {
            pageTitle: 'Generator etykiet billboardowych',
            customerLabel: 'Klient',
            searchLabel: 'Szukaj',
            actions: {
                back: 'Powrót',
                workspace: 'Zmiana stanowiska',
                importData: 'Importuj dane',
                printSelected: 'Drukuj zaznaczone etykiety',
                import: 'Importuj'
            },
            table: {
                noData: 'Brak danych',
                headers: {
                    routeNumber: 'Trasa',
                    commercialTerm: 'Ekipa',
                    productName: 'Produkt',
                    numberOfSets: 'Ilość kompletów',
                    actions: 'Akcje'
                },
                expanded: {
                    title: 'Etykiety',
                    headers: {
                        boxNumbering: 'Nr etykiety',
                        numberOfSets: 'Ilość kompletów',
                        actions: 'Akcje'
                    }
                }
            },
            dialogs: {
                changeCustomer: {
                    title: 'Zmiana klienta',
                    content: 'Czy na pewno zmienić klienta? Wszystkie zaimportowane dane zostaną utracone.',
                    confirm: 'Kontynuuj'
                },
                manyLabels: {
                    title: 'Wydruk wielu etykiet',
                    content: 'Uwaga! Liczba etykiet do wydruku - {count} szt.',
                    confirm: 'Kontynuuj'
                },
                reimport: {
                    title: 'Ponowny import danych',
                    content:
                        'Czy na pewno chcesz ponownie zaimportować dane? Wszystkie dotychczas zaimportowane zostaną utracone.',
                    confirm: 'Kontynuuj'
                }
            }
        },
        revisory: {
            pageTitle: 'Generator etykiet rewizyjnych',
            actions: {
                back: 'Powrót',
                search: 'Szukaj',
                print: 'Drukuj etykietę'
            },
            form: {
                customer: 'Klient',
                number: 'Numer',
                numberHint: 'Proszę zeskanować kartę lub wpisać cały numer.',
                jobNumber: 'Numer zlecenia',
                objectType: 'Typ obiektu',
                noObjects: 'Nie znaleziono obiektów',
                product: 'Produkt',
                noProducts: 'Nie znaleziono produktów',
                date: 'Data'
            },
            qrError: 'Błąd parsowania kodu QR'
        },
        history: {
            pageTitle: 'Etykiety / Historia wydruków',
            actions: {
                back: 'Powrót do listy'
            },
            filters: {
                userId: 'Użytkownik',
                noUsers: 'Nie znaleziono',
                noResults: 'Nie znaleziono',
                dateFrom: 'Od',
                dateTo: 'Do'
            },
            usersSearch: {
                emptyPrompt: 'Wpisz aby wyszukać użytkownika',
                searching: 'Wyszukiwanie...',
                noResults: 'Nie znaleziono użytkownika'
            },
            table: {
                headers: {
                    printedBy: 'Drukujący',
                    createdAt: 'Data wydruku',
                    type: 'Typ etykiety',
                    client: 'Klient',
                    quantity: 'Ilość',
                    fileName: 'Nazwa pliku'
                }
            }
        }
    },

    distributors: {
        menuTitle: 'Rozdzielniki',
        pageTitle: 'Wysyłki / Rozdzielniki',
        actions: {
            upload: 'Wgraj rozdzielnik'
        },
        table: {
            headers: {
                number: 'Numer wpisu',
                orderNumber: 'Numer zamówienia',
                shippingDate: 'Data nadania',
                status: 'Status',
                actions: 'Akcje'
            }
        },
        tooltips: {
            edit: 'Edytuj',
            delete: 'Usuń',
            download: 'Pobierz',
            approve: 'Zatwierdź',
            approved: 'Zatwierdzony'
        },
        uploadDialog: {
            title: 'Dodaj nowy rozdzielnik',
            fields: {
                orderNumber: 'Numer zamówienia',
                shippingDate: 'Data nadania',
                courier: 'Kurier',
                deliveryMethod: 'Forma dostawy'
            },
            dropzone: {
                label: 'Miejsce do wgrania rozdzielnika',
                hint: 'Przeciągnij plik .xlsx lub kliknij, aby wybrać'
            },
            search: {
                prompt: 'Szukaj zamówienia',
                minLength: 'Wpisz przynajmniej 3 znaki',
                loading: 'Trwa wyszukiwanie...',
                notFound: 'Brak znalezionych zamówień',
                notFoundScanned: 'Nie znaleziono zamówienia.'
            },
            errors: {
                invalidExtension: 'Dozwolony jest tylko plik w formacie .xlsx.',
                fileTooLarge: 'Plik jest zbyt duży. Maksymalny rozmiar to 25 MB.',
                invalidFormat: 'Szablon pliku niezgodny z standardem. Wgraj prawidłowy plik rozdzielnika.',
                orderRequired: 'Numer zamówienia jest wymagany.',
                fileRequired: 'Plik rozdzielnika jest wymagany.',
                shippingDateRequired: 'Data nadania jest wymagana.',
                courierRequired: 'Kurier jest wymagany.',
                deliveryMethodRequired: 'Forma dostawy jest wymagana.'
            },
            actions: {
                cancel: 'Anuluj',
                submit: 'Wczytaj'
            }
        },
        deleteDialog: {
            title: 'Usuwanie rozdzielnika',
            content: 'Czy na pewno chcesz usunąć rozdzielnik?'
        },
        approveDialog: {
            title: 'Zmiana statusu rozdzielnika',
            content: 'Czy chcesz zmienić status rozdzielnika?'
        },
        service: {
            fetchListError: 'Pobranie listy rozdzielników nie powiodło się.',
            createSuccess: 'Rozdzielnik został wgrany.',
            createError: 'Wgranie rozdzielnika nie powiodło się.',
            deleteSuccess: 'Rozdzielnik został usunięty.',
            deleteError: 'Usunięcie rozdzielnika nie powiodło się.',
            fetchCarriersError: 'Pobranie listy kurierów nie powiodło się.',
            fetchOrdersError: 'Wyszukiwanie zamówień nie powiodło się.',
            updateStatusSuccess: 'Status rozdzielnika został zmieniony.',
            updateStatusError: 'Zmiana statusu rozdzielnika nie powiodła się.'
        },
        detail: {
            pageTitle: 'Wysyłki / Rozdzielniki / Szczegóły',
            actions: {
                backToList: 'Powrót do listy',
                edit: 'Edytuj',
                print: 'Drukuj',
                reprintTooltip: 'Pobierz etykietę'
            },
            filters: {
                carrier: 'Kurier',
                allCarriers: 'Wszyscy kurierzy'
            },
            table: {
                selectAll: 'Zaznacz wszystkie',
                headers: {
                    id: 'ID',
                    companyName: 'Nazwa (firmy)',
                    fullName: 'Imię i nazwisko',
                    street: 'Ulica',
                    countryCode: 'Kod kraju',
                    postalCode: 'Kod pocztowy',
                    city: 'Miasto',
                    phone: 'Telefon',
                    carrier: 'Kurier',
                    deliveryMethod: 'Forma dostawy',
                    cartonCount: 'Liczba kartonów',
                    action: 'Akcja',
                    trackingNumber: 'Nr listu'
                }
            },
            editDialog: {
                title: 'Edycja pozycji',
                fields: {
                    boxCount: 'Kartony',
                    boxCountInvalid: 'Podaj liczbę naturalną',
                    carrier: 'Kurier',
                    deliveryMethod: 'Forma dostawy'
                },
                noCarriers: 'Nie znaleziono kurierów',
                noDeliveryMethods: 'Nie znaleziono form dostawy',
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            printDialog: {
                title: 'Nadpisywanie etykiet',
                content: 'Co najmniej jedna pozycja posiada wygenerowaną etykietę. Czy na pewno chcesz ją nadpisać?',
                confirm: 'Tak',
                cancel: 'Nie'
            },
            labelErrors: {
                title: 'Błąd generowania etykiet dla pozycji:',
                unknownError: 'Nieznany błąd generowania'
            },
            editItemsDialog: {
                title: 'Edycja zaznaczonych pozycji',
                fields: {
                    courier: 'Kurier',
                    deliveryMethod: 'Zmień formę dostawy'
                },
                cancel: 'Anuluj',
                save: 'Zapisz'
            },
            service: {
                fetchDetailError: 'Pobranie szczegółów rozdzielnika nie powiodło się.',
                updateCartonCountSuccess: 'Liczba kartonów została zaktualizowana.',
                updateCartonCountError: 'Aktualizacja liczby kartonów nie powiodła się.',
                updateDeliveryMethodSuccess: 'Forma dostawy została zaktualizowana.',
                updateDeliveryMethodError: 'Aktualizacja formy dostawy nie powiodła się.'
            }
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
